import { render } from "./Aziende.vue?vue&type=template&id=0361b080&scoped=true"
import script from "./Aziende.vue?vue&type=script&lang=js"
export * from "./Aziende.vue?vue&type=script&lang=js"

import "./Aziende.vue?vue&type=style&index=0&id=0361b080&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0361b080"]])

export default __exports__